import { IpifyGeoClient } from "@redotech/ipify-client";
import { StorefrontIpGeolocationProvider } from "@redotech/redo-model/widget";
import { assertNever } from "@redotech/util/type";
import { createContext, memo } from "react";
import { IpifyLocationClient } from "./ipify-location-client";
import { LocationApiClient } from "./location-api-client";
import { StorefrontEmbedServerLocationClient } from "./storefront-embed-server-location-client";

export const LocationClientContext = createContext<
  LocationApiClient | undefined
>(undefined);

export interface LocationClientProviderProps {
  children: React.ReactNode;
  clientType?: StorefrontIpGeolocationProvider;
}

export const LocationClientProvider = memo(function LocationClientProvider({
  children,
  clientType,
}: LocationClientProviderProps) {
  const client = getLocationApiClientFromEnv({ clientType });

  return (
    <LocationClientContext.Provider value={client}>
      {children}
    </LocationClientContext.Provider>
  );
});

export const getLocationApiClientFromEnv = ({
  clientType,
}: {
  clientType?: StorefrontIpGeolocationProvider;
}): LocationApiClient => {
  const clientTypeWithFallback =
    clientType ?? StorefrontIpGeolocationProvider.IPIFY;

  switch (clientTypeWithFallback) {
    case StorefrontIpGeolocationProvider.IPIFY:
      return new IpifyLocationClient(
        new IpifyGeoClient(
          globalThis.redoStorefront?.env?.IPIFY_API_KEY ??
            process.env.IPIFY_API_KEY!,
        ),
      );
    case StorefrontIpGeolocationProvider.STOREFRONT_EMBED_SERVER:
      return new StorefrontEmbedServerLocationClient(
        globalThis.redoStorefront?.env?.REDO_API_URL ??
          process.env.REDO_API_URL!,
      );
    default:
      return assertNever(clientTypeWithFallback);
  }
};
